import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'prefix'
})
export class PrefixPipe implements PipeTransform {

  transform(input: string, prefix: string): string {
    return (input && input.trim().length > 0) ? `${prefix}${input}` : null;
  }
}
